import { useContext, useState, useEffect, useCallback } from 'react';
import { Select, Skeleton, Icon } from '@ok/okd';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import classNames from 'classnames';
import getCoinIconUrl from '@common/utils/CoinIcons';
import { getCurCurrencyByUrl } from '../../common/util';

import './index.less';

export default () => {
  const { currencyList, getCurrencyDetail } = useContext(CurrencyInfoContext);
  const [selectOptions, setSelectOptions] = useState([]);

  const onCurrencyChange = useCallback(
    (currency) => {
      const { label } = currency;
      const selectedCurrency = currencyList?.find(
        ({ symbol }) => symbol === label
      );
      getCurrencyDetail(selectedCurrency);
    },
    [getCurrencyDetail, currencyList]
  );

  useEffect(() => {
    const options =
      currencyList?.map((c) => ({
        ...c,
        value: c.id,
        label: c.symbol,
      })) || [];

    setSelectOptions(options);
  }, [currencyList]);

  const curCurrency = getCurCurrencyByUrl(currencyList);

  return (
    <div className="currency-selector-box">
      {currencyList?.length ? (
        <>
          <div className="currency-icon-box">
            <img
              src={getCoinIconUrl(curCurrency?.symbol || 'BTC', 120)}
              alt="currency icon"
            />
          </div>
          <div className="currency-selector-wrapper">
            <Select
              type={Select.TYPE.text}
              value={curCurrency?.id}
              options={selectOptions}
              searchable={false}
              isPcShowCheck
              className="currency-selector"
              optionContClassName="currency-selector-option-wrapper"
              valueContClassName="currency-selector-value"
              onChange={onCurrencyChange}
              suffixIcon={(active) => {
                return (
                  <Icon
                    className={classNames(
                      'okj-common-spread',
                      'currency-select-suffix-icon',
                      { active }
                    )}
                  />
                );
              }}
              renderOption={({ option, isActive, activeIcon }) => {
                const { id, symbol, fullName } = option;
                return (
                  <div className="selector-option-box" key={id}>
                    <div className="selector-option-label-box">
                      <img
                        src={getCoinIconUrl(symbol, 120)}
                        alt="currency icon"
                      />
                      <div className="selector-option-info-box">
                        <div className="selector-option-label">{symbol}</div>
                        <div className="selector-option-name">{fullName}</div>
                      </div>
                    </div>
                    {isActive && activeIcon}
                  </div>
                );
              }}
            />
            <div className="currency-name">{curCurrency.fullName}</div>
          </div>
        </>
      ) : (
        <div className="currency-selector-skeleton-box">
          <Skeleton.Avatar className="currency-icon-box"></Skeleton.Avatar>
          <div className="currency-selector-wrapper-skeleton">
            <Skeleton.Input className="currency-selector"></Skeleton.Input>
            <Skeleton.Input className="currency-name"></Skeleton.Input>
          </div>
        </div>
      )}
    </div>
  );
};
